import Root from '@pinecast/tj-spa/Root';

import mount, {applyProps} from '../mount';

const components: Array<any> = [Root];

components.forEach(component => {
  const elements = document.querySelectorAll(component.selector);
  if (!elements.length) {
    return;
  }
  Array.from(elements).forEach((elem: HTMLElement) => {
    mount(applyProps(component, elem), elem);
  });
});
